import React, { useState, useEffect, useRef } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import GovernanceContent from "../../components/GovernanceContent";
import CreateVoteModal from "../../components/CreateVoteModal";
import { getConnectedAddress } from "../../config/web3";
import { ENV } from "../../config/config";
import { useAccount } from 'wagmi';
import { useModal } from 'connectkit';

const Home = () => {
  const { address, isConnected } = useAccount();
  const { setOpen } = useModal();
  const [showCreateVote, setShowCreateVote] = useState(false);
  const [activeTab, setActiveTab] = useState("voting");
  
  // Refs to store refresh functions from GovernanceContent components
  const refreshFunctionsRef = useRef({});

  useEffect(() => {
    if (address && isConnected) {
      localStorage.setItem("address", address);
    }
  }, [address]);

  // Function to refresh proposals after creating a new one
  const handleProposalCreated = () => {
    // Refresh the current active tab
    if (refreshFunctionsRef.current[activeTab]) {
      refreshFunctionsRef.current[activeTab]();
    }
    
    // Also refresh the voting tab if it's not the active tab
    if (activeTab !== "voting" && refreshFunctionsRef.current["voting"]) {
      refreshFunctionsRef.current["voting"]();
    }
  };

  // Function to register refresh functions from GovernanceContent components
  const registerRefreshFunction = (type, refreshFn) => {
    refreshFunctionsRef.current[type] = refreshFn;
  };

  // Handle create proposal button click
  const handleCreateProposalClick = () => {
    if (!isConnected) {
      // If wallet is not connected, open ConnectKit modal to connect wallet
      setOpen(true);
      return;
    }
    setShowCreateVote(true);
  };

  return (
    <div className="home-container">
      <div className="container">
        <div className="flex-between align-center mb-3">
          <h1 className="mb-0">Governance</h1>
          <button 
            className="btn-primary" 
            onClick={handleCreateProposalClick}
          >
            Create Proposal
          </button>
        </div>
        
        <Tabs 
          defaultActiveKey="voting" 
          id="goverance-tabs" 
          className="mb-3"
          onSelect={(key) => setActiveTab(key)}
        >
          <Tab eventKey="voting" title="Voting">
            <GovernanceContent 
              type="voting" 
              onRegisterRefresh={registerRefreshFunction}
            />
          </Tab>
          <Tab eventKey="passed" title="Passed">
            <GovernanceContent 
              type="passed" 
              onRegisterRefresh={registerRefreshFunction}
            />
          </Tab>
          <Tab eventKey="rejected" title="Rejected">
            <GovernanceContent 
              type="rejected" 
              onRegisterRefresh={registerRefreshFunction}
            />
          </Tab>
          {getConnectedAddress() === ENV.adminAddress && (
            <Tab eventKey="finalize" title="Finalize Vote">
              <GovernanceContent 
                type="finalize" 
                onRegisterRefresh={registerRefreshFunction}
              />
            </Tab>
          )}
        </Tabs>

        <CreateVoteModal
          show={showCreateVote}
          setShowModal={setShowCreateVote}
          onHide={() => setShowCreateVote(false)}
          onProposalCreated={handleProposalCreated}
        />
      </div>
    </div>
  );
};

export default Home;